import { createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import { IEntityState, buildFeatureState } from '@briebug/ngrx-auto-entity';
import { User } from './user.model';

export interface IUserState {
    user: IEntityState<User>;
}

export const USER = 'user';

export const userState = createFeatureSelector<IUserState>(
    USER
);

export const { initialState: initialUserState, selectors, facade: userFacadeBase } = buildFeatureState(
    User,
    USER,
    userState
);

export function userReducer(state = initialUserState): IEntityState<User> {
    return state;
}

export const userReducers: ActionReducerMap<IUserState> = {
    user: userReducer
};